import cx from 'classnames';
import styles from '../RequestService.module.scss';
import { v4 as uuid } from 'uuid';
import { useBreakpoint } from '../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { StepIndicatorProps } from '../types';

export const RequestServiceStepIndicator = ({
  classname
}: StepIndicatorProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const loaderCount = [...Array(isMD ? '' : 3)];
  return (
    <div className="text-center">
      {loaderCount.map((_value) => (
        <span
          className={cx([
            'd-inline-block mx-2',
            styles['request-service__step-indecator'],
            styles['request-service__active-step-indecator'],
            classname
          ])}
          key={uuid()}
        ></span>
      ))}
    </div>
  );
};
